import { gql } from 'graphql-request'

export const GetStationDetailsGql = gql`
  query stationDetails($recordNumber: String!) {
    stationDetails(recordNumber: $recordNumber) {
      stationGroupDescription
      rwsStatus
      zqStatus
      zqrxStatus
      isRws
    }
  }
`
